/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import {createRoot } from 'react-dom/client'
import { SoftUIControllerProvider } from "context";
import { GoogleOAuthProvider } from "@react-oauth/google";
import './App.css'
import RoutesProvider from "context/RoutesContext";
import { QueryParamsProvider } from "context/QueryParamsContext";
import { DateFormatProvider } from "context/DateFormatContext";
import { UserProvider } from "context/UserContext";
import { DomainProvider } from "context/DomainContext";
import { SitesProvider } from "context/SitesContext";
import { AuthProvider } from 'context/AuthContext';
import { SettingsProvider } from "context/SettingsContext";


const container = document.getElementById("root")
const root = createRoot(container)
const CLIENT_ID= process.env.REACT_APP_GOOGLE_CLIENT_ID

root.render(
  <BrowserRouter>
  <SoftUIControllerProvider>
    <GoogleOAuthProvider clientId={CLIENT_ID}>
        <AuthProvider>
          <SettingsProvider>
      <DomainProvider>
         <UserProvider>
        <SitesProvider>
      <RoutesProvider>
        <QueryParamsProvider>
          <DateFormatProvider>
           
      <App />
    
      </DateFormatProvider>
      </QueryParamsProvider>
      </RoutesProvider>
      </SitesProvider>
        </UserProvider>
        
      </DomainProvider>
      </SettingsProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  </SoftUIControllerProvider>
  </BrowserRouter>
)
